import { openModal } from '../actions';
import { ModalDataSessionType } from './types';

export const openSessionModal = (data: ModalDataSessionType) =>
  openModal('SESSION', { data });
